import React, { useState, useEffect } from 'react';
import '../styling/forms.css';

const ComplaintForm = ({ category, onSubmit }) => {
  const [form, setForm] = useState({
    complaintCategory: category,
    dateOfEvent: new Date().toISOString().split('T')[0],
    location: '',
    staffInvolved: '',
    patientExperienceArea: '',
    description: '',
    desiredResolution: '',
    severity: 'Low',
    contactedBy: '',
    followUpNeeded: 'No'
  });

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const update = (e) => {
    const { name, value } = e.target; setForm((s) => ({ ...s, [name]: value }));
  };
  const submit = (e) => { e.preventDefault(); onSubmit(form); };

  return (
    <div className="form-wrapper">
      <h1>{category}</h1>
      <form className="card-form" onSubmit={submit}>
        <label>
          Date of Event
          <input type="date" name="dateOfEvent" value={form.dateOfEvent} onChange={update} required />
        </label>
        <label>
          Location/Operatory
          <input name="location" value={form.location} onChange={update} />
        </label>
        <label>
          Staff Involved
          <input name="staffInvolved" value={form.staffInvolved} onChange={update} />
        </label>
        <label>
          Area of Concern
          <select name="patientExperienceArea" value={form.patientExperienceArea} onChange={update}>
            <option value="">Select</option>
            <option>Wait Time</option>
            <option>Communication</option>
            <option>Billing/Financial</option>
            <option>Clinical Care</option>
            <option>Facility/Environment</option>
            <option>Other</option>
          </select>
        </label>
        <label>
          Severity
          <select name="severity" value={form.severity} onChange={update}>
            <option>Low</option>
            <option>Moderate</option>
            <option>High</option>
          </select>
        </label>
        <label>
          Description
          <textarea name="description" rows="6" value={form.description} onChange={update} required />
        </label>
        <label>
          Desired Resolution
          <textarea name="desiredResolution" rows="4" value={form.desiredResolution} onChange={update} />
        </label>
        <label>
          Contacted By
          <input name="contactedBy" value={form.contactedBy} onChange={update} />
        </label>
        <label>
          Follow-up Needed
          <select name="followUpNeeded" value={form.followUpNeeded} onChange={update}>
            <option>No</option>
            <option>Yes</option>
          </select>
        </label>
        <div className="actions">
          <button type="submit" className="primary">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default ComplaintForm;


